import React from "react";
import MultiTabDialog from "../components/material_react_table/multi_tab_dialog";
import { OverrideDialog } from "../components/dialogs/override_dialog";

export const ModalContext = React.createContext();

export const ModalProvider = ({ children }) => {
  const [overrideModalOpen, setOverrideModalOpen] = React.useState(false);
  const [overrideModalProps, setOverrideModalProps] = React.useState(false);
  const [dialogModalOpen, setDialogModalOpen] = React.useState(false);
  const [dialogModalProps, setDialogModalProps] = React.useState({});

  return (
    <ModalContext.Provider
      value={{
        openOverrideModal: (props) => {
          setOverrideModalProps(props);
          setOverrideModalOpen(true);
        },
        closeOverrideModal: () => {
          setOverrideModalOpen(false);
        },
        overrideModalOpen,
        openDialogModal: (props) => {
          setDialogModalProps(props);
          setDialogModalOpen(true);
        },
        closeDialogModal: () => {
          setDialogModalOpen(false);
        },
      }}
    >
      {children}
      <MultiTabDialog
        open={dialogModalOpen}
        onClose={() => setDialogModalOpen(false)}
        dialogTabs={dialogModalProps.dialogTabs}
      />
      <OverrideDialog open={overrideModalOpen} setOpen={setOverrideModalOpen} siteData={overrideModalProps.siteData} />
    </ModalContext.Provider>
  );
};

export const useModal = () => React.useContext(ModalContext);
